var React = require('react');

function Ban (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M406.78 361.53a186.53 186.53 0 0 1-45.25 45.25L105.22 150.47a186.53 186.53 0 0 1 45.25-45.25z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm130.11 378.11A184 184 0 1 1 440 256a182.82 182.82 0 0 1-53.89 130.11z","className":"fa-primary","key":2})]);
}

Ban.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Ban;

Ban.default = Ban;
